import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    setDisplayElementSummary,
    shouldUpdateModulesSet,
    toggleElementShowingHidden
} from "../../store/configuratorStateSlice";
import ElementReorderButtons from "./ElementReorderButtons";
import Select from "../common_elements/Select";
import Radio from "../common_elements/Radio";
import {
    displayGeneratedShapeElements,
    productSelectionChanged,
    setShapedAttributes
} from "../../store/product/productSelectionsSlice";
import {useGenerateShapeElementsMutation} from "../services/productApi";
import GenerateShapeElementsButton from "./GenerateShapeElementsButton";
import ExceptionMessage from "../common_elements/ExceptionMessage";


const ElementShapeOptionalStep = (props) => {
    const shapedAttributes = useSelector(state => state.productSelectionsReducer.shapedAttributes)
    const shapedSelections = useSelector(state => state.productSelectionsReducer.shapedSelections)
    const [showException, setShowException] = useState(false);
    const [messages, setMessages] = useState([]);
    const [exceptionLeft, setExceptionLeft] = useState(0);
    const [exceptionTop, setExceptionTop] = useState(0);
    const disabledFields = useSelector(state => state.disabledFieldsReducer.disabledFields);
    const hasElements = useSelector(state => state.configuratorStateReducer.hasElements);
    const dispatch = useDispatch();

    const [filledIn, setFilledIn] = useState([]);

    useEffect(() => {
        dispatch(setShapedAttributes())
    }, [])


    const hideExceptionMessage = () => {
        setShowException(false)
        setMessages([]);
    }

    const exceptionMessage = () => {
        if(!showException || messages.length == 0) {
            return
        }

        return <ExceptionMessage message={messages} posLeft={exceptionLeft} posTop={exceptionTop}/>
    }

    const getDisabledSelections = (attribute) => {
        const attributeData = disabledFields.find(df => df.id === attribute.id);
        if(attributeData){
            return attributeData.disabledSelections;
        } else {
            return [];
        }
    }

    const updateFilledIn = (option, value) => {
        if(!value) {
            const isLength = option.internal_name.includes('length')
            if(isLength) {
                // handle cases where we have to remove multiple lengths if once is removed
                const fi = filledIn.filter(opt => !opt.includes('length'))
                const lengthId = parseInt(option.internal_name.match('[0-9]'))
                for(let i = 1; i <= lengthId; i++){
                    fi.push('length_' + i)
                }
                // clear selection for lengths x up to 4
                for(let x = lengthId; x <= 4;x++){
                    const optionName = 'length_' + x
                    dispatch(productSelectionChanged(shapedAttributes.find(o => o.internal_name === optionName), "" ))
                }
                setFilledIn(fi);
            } else {
                setFilledIn(filledIn.filter(opt => option.internal_name !== opt))
            }
        } else if(!filledIn.includes(option.internal_name)){
            const updatedFilledIn = Object.assign([], filledIn).concat([option.internal_name])
            setFilledIn(updatedFilledIn)
        }
    }

    const handleAttribute = (option, value) => {
        updateFilledIn(option, value)
        // only update modules when length changes
        if(option.internal_name == 'row_layout') {
            dispatch(shouldUpdateModulesSet(true))
        } else {
            dispatch(shouldUpdateModulesSet(false))
        }
        dispatch(productSelectionChanged(option, value ))

    }

    const displayOption = (option) => {
        const name = option.part_of_geometry && option.optional ? option.name + " (Optional)" : option.name;
        return (
            <div key={'attribute-selection-' + option.id}>
                <div className="configurator-step"  >{/*onMouseLeave={() => shouldHideException('radio')} onBlur={() => shouldHideException('select')}>*/}
                    <div className="row flex-row">
                        <div className="title small-12 medium-2 columns">
                            <h3>{name}</h3>
                        </div>
                        <div className="selection small-12 medium-10 columns">
                            <fieldset>
                                {radioOrSelect(option)}
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const radioOrSelect = (option) => {
        let values = option.values;
        // let value = props.currentValue == "" ? undefined : props.currentValue
        let value = option.selection;
        if (values.length > 5) {
            return (
                <label title={messages ? messages.join(', '):""}>
                    <Select key={option.id + "-elementShape-" + value }
                            attributes={option}
                            propType={'ATTRIBUTE'}
                            currentValue={value}
                            fieldId={option.sku_order}
                            disabledSelections={getDisabledSelections(option)}
                            // ignoreDisabled={ignoreDisabledFields()}
                            hasEmptyField={true}
                            onClick={(e) => handleDisabledClick(e, option)}
                            onChange={() => hideExceptionMessage()}
                            handleAttribute={(v) => handleAttribute(option, v)}
                            // errorField={isErrorField()}
                    />
                </label>)
        } else {
            return  (
                <label title={messages ? messages.join(', '):""}>
                    <Radio key={option.id + "-elementShape-" + value}
                           attributes={option}
                           propType={'ATTRIBUTE'}
                           currentValue={value}
                           // group={generateKey()}
                           checkType={'radio'}
                           fieldId={option.sku_order}
                           disabledSelections={ getDisabledSelections(option)  }
                           // ignoreDisabled={ignoreDisabledFields()}
                           onChange={() => hideExceptionMessage()}
                           onClick={(e) => handleDisabledClick(e, option)}
                           handleAttribute={(v) => handleAttribute(option, v)}
                           // errorField={isErrorField()}
                    />
                </label>
            )

        }
    }


    // TODO implement handleDisabledClick
    const handleDisabledClick = (e, attribute) => {
        const matchingField = disabledFields.find(df => df.id === attribute.id);
        if(matchingField.messages) {
            const mouseX = e.pageX;
            // 37 is to move message up
            const posY = $(e.target).offset().top - $('#element-shape-exception-container').offset().top - 37
            setMessages(matchingField.messages);
            setShowException(true);
            setExceptionLeft(mouseX)
            setExceptionTop((posY) );
        }
    }
    // Some weird logic here but this is how the business logic is
    // node start and length 1 are required, everything else is optional
    // other lengths should only display if length 1 is filled
    const showOptionSteps = () => {
        const optionSteps = [];
        let showNext = false;
        shapedAttributes.forEach((opt, i) => {
            const currentSelection = shapedSelections.find(ss => ss.internal_name == opt.internal_name);
            // LITTLE BIT OF JANKYNESS HERE FOR STEP BY STEP LOGIC
            // For standard attributes, all ids must be sequential so we can go 1 by 1
            // shapes do not follow this as they have some in required and some in optional,
            // and they tend to be added all over the place. This first check is mainly for edit,
            // but also runs once a selection is made, it takes the selection and forces next to show
            if (currentSelection && currentSelection.selection) {
                optionSteps.push(displayOption(currentSelection))
                showNext = true
            } else {
                const isLength = opt.internal_name.includes('length')
                const REQUIRED_LENGTH_NAME = 'length_1'
                let shouldDisplay = false;
                // CONTINUED
                // here we look for all other lengths other than length 1, this does
                // NOT INCLUDE LENGTH_1 since we it specifically looks for previous lengths
                // to create step by step effect.
                if (isLength && opt.internal_name !== REQUIRED_LENGTH_NAME) {
                    const lengthId = parseInt(opt.internal_name.match('[0-9]'))
                    const previousId = 'length_' + (lengthId - 1).toString();
                    const previousSelection = shapedSelections.find(op => op.internal_name === previousId);
                    if (previousSelection && previousSelection.selection) {
                        shouldDisplay = true
                    }
                // Starting element and Length_1 are handled here via i and showNext.
                } else {
                    if (i === 0 || showNext) {
                        shouldDisplay = true;
                    }
                    showNext = filledIn.includes(opt.internal_name)
                }

                if (shouldDisplay) {
                    optionSteps.push(displayOption(opt))
                }
        }

        })
        return optionSteps;
    }

    if(!hasElements){
        return null;
    }

    return (
        <div className="panel" id="element-steps">
            <div className="configurator-step element-wrapper no-border is-shape" id="element-shape-exception-container">
                <div className={`pattern-title-wrapper ${shapedAttributes.length ===  0 ? ' no-border ' : ' border-bottom '}`}>
                    <div style={{display: 'flex', justifyContent:'space-between', alignItems: 'center'}}>
                        <h2>Geometry</h2>
                    </div>
                </div>
                <div className='row'>
                    { showOptionSteps() }
                    { exceptionMessage() }
                    <GenerateShapeElementsButton />
                </div>
            </div>
        </div>

    )
};

export default ElementShapeOptionalStep;